import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Contractor } from '../types/contractor'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import { useRequests } from '../requests/useRequests'
import { RefreshActions } from '../state/refresh'
import PhoneInput from 'react-phone-input-2'
import { validateMail, validatePhone } from '../utils/validators'
import { ErrorAlert } from '../formik/ErrorAlert'

interface NewOrEditContractorDialogProps {
  contractor: Contractor | null
  handleClose: (b: boolean) => void
}

const NewOrEditContractorDialog = ({
  contractor,
  handleClose
}: NewOrEditContractorDialogProps): JSX.Element => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()

  const initContractor = {
    id: contractor?.id,
    name: contractor?.name,
    taxId: contractor?.taxId,
    street: contractor?.street,
    city: contractor?.city,
    zipCode: contractor?.zipCode,
    accountNumber: contractor?.accountNumber,
    email: contractor?.email,
    phoneNumber: contractor?.phoneNumber,
    userId: contractor?.userId
  }

  const validate = (contractor: Partial<Contractor>): Partial<Contractor> => {
    const errors: typeof contractor = {}

    contractor.email !== undefined &&
      validateMail(contractor.email ?? null, e => (errors.email = e))
    contractor.phoneNumber !== undefined &&
      validatePhone(
        contractor.phoneNumber ?? null,
        e => (errors.phoneNumber = e)
      )

    return errors
  }

  const onSubmit = useCallback(
    async (contractor: Partial<Contractor>): Promise<void> => {
      handleClose(true)
      const isEdited = contractor.id !== undefined

      if (isEdited) {
        await requestMaker.updateContractor(contractor)
      } else {
        await requestMaker.createContractor(contractor)
      }
      dispatch(RefreshActions.refreshUserState())
    },
    [requestMaker, dispatch, handleClose]
  )

  const formik = useFormik({
    initialValues: initContractor,
    onSubmit,
    enableReinitialize: true,
    validate
  })

  return (
    <div>
      <Dialog open onClose={handleClose}>
        <form>
          <DialogTitle>Contractor</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin='dense'
              id='name'
              label='Name'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.name}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='taxId'
              label='Tax id'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.taxId}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='street'
              label='Street'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.street}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='city'
              label='City'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.city}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='zipCode'
              label='Zip code'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.zipCode}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='accountNumber'
              label='Account number'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.accountNumber}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='email'
              label='Email'
              type='email'
              fullWidth
              variant='standard'
              value={formik.values.email}
              onChange={formik.handleChange}
              style={{ marginBottom: '3vh' }}
            />
            <ErrorAlert formik={formik} name='email' />
            {/* <TextField
              margin='dense'
              id='phoneNumber'
              label='Phone number'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
            />{' '} */}
            <br />
            <div style={{ width: '20vw' }}>
              <PhoneInput
                placeholder='Enter phone number'
                inputClass='material'
                containerClass='bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal'
                value={formik.values.phoneNumber}
                onChange={phoneNumber => {
                  void formik.setFieldValue('phoneNumber', phoneNumber)
                }}
              />
              <ErrorAlert formik={formik} name='phoneNumber' />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose as any}>Cancel</Button>
            <Button onClick={formik.handleSubmit as any}>Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}

export default NewOrEditContractorDialog
